import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  pending: false,
  snapshot: null,
}

export const reviewUploadedModelsResumeSlice = createSlice({
  name: 'review-uploaded-models-resume',
  initialState,

  reducers: {
    saveReviewResumeState: (state, action) => {
      state.pending = true
      state.snapshot = action.payload
    },

    clearReviewResumeState: (state) => {
      state.pending = false
      state.snapshot = null
    },
  },
})

export const { saveReviewResumeState, clearReviewResumeState } =
  reviewUploadedModelsResumeSlice.actions

export default reviewUploadedModelsResumeSlice.reducer
